export default {
    ROUTING_EVENT: 'single-spa:routing-event',
    BEFORE_ROUTING_EVENT: 'single-spa:before-routing-event',
    BEFORE_MOUNT_ROUTING_EVENT: 'single-spa:before-mount-routing-event',
};
